import { Profile } from '../types';
import { contact } from './contact';
import { experience } from './experience';
import { education } from './education';
import { skills } from './skills';
import { projects } from './projects';
import { volunteering } from './volunteering';
import { accomplishments } from './accomplishments';
import { languages } from './languages';

export const profile: Profile = {
    name: 'Ali Rajab',
    roles: [
        'Flutter Developer',
        'Software Engineer',
        'Product Manager',
        'Web3 Engineer',
    ],
    tagline: 'Building high-impact apps at scale — Flutter, Web3 & Full-Stack',
    location: 'Hama, Syria',
    contact,
    stats: [
        { value: '5+', label: 'Years Experience' },
        { value: '8+', label: 'Apps Published' },
        { value: '2K+', label: 'Users Served' },
        { value: '250+', label: 'Volunteer Hours' },
    ],
    summary: "Software engineer with 5+ years shipping cross-platform apps and full-stack systems adopted by thousands of users. Proven track record in team leadership (led teams of 9 engineers, boosting productivity by 75%), system optimization (80% server load reduction), and Web3 (DeFi dApps on SUI Network serving 2,000+ holders).<br><br>I bridge stakeholder vision with technical execution — whether building Flutter apps from scratch, refactoring critical APIs, or deploying smart contracts. Agile-focused, performance-obsessed, and fluent across mobile, web, and blockchain stacks.<br><br><strong>Let the machine automate the tasks.</strong>",
    experience,
    education,
    skills,
    projects,
    volunteering,
    accomplishments,
    languages,
};
